import { render, staticRenderFns } from "./RbuEdition.vue?vue&type=template&id=835a3588"
import script from "./RbuEdition.vue?vue&type=script&lang=js"
export * from "./RbuEdition.vue?vue&type=script&lang=js"
import style0 from "./RbuEdition.vue?vue&type=style&index=0&id=835a3588&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports